// @ts-strict-ignore
import { Component, EventEmitter, Input, Output, ViewChild, OnInit } from '@angular/core';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { LMHtmlUrlDocComponent } from '@html/lm-html-url-doc.component';
import { LMPanelTransactionEvent } from '@form/services';
import { LMListTransactionEvent } from '@list/lm-list.component';
import { LMContextService } from '@services/lm-context.service';
import { AppConstants } from '@utils/app.constants';
import { LMRefreshRequest } from '@app/components';
import { Observable, of } from 'rxjs';

// automationId="{{panel.automationId}}"

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[lm-page-pane-url-component]',
  standalone: false,
  template: `
    @if (url) {
      <lm-html-url-doc #LMHtmlUrlDoc
        parentContainerId="{{!testVersion1 ? panel.id : null}}"
        [isHtmlFragment]="true"
        [url]="url"
        [isWFM]="isWFM"
        automationId="{{automationId}}"
        (htmlUrlDisplayed)="onHtmlUrlDisplayed($event)"
        (landmarkCustomReady)="onLandmarkCustomReady($event)"
        (landmarkApiLoaded)="onLandmarkApiLoaded($event)"
        (notifyUrlTransactionComplete)="onNotifyUrlTransactionComplete($event)"
      ></lm-html-url-doc>
    }
    `,
  styleUrls: ['./lm-page-pane-url.component.scss'],
})
export class LMPagePaneUrlComponent implements OnInit {
  @ViewChild('LMHtmlUrlDoc') htmlDocComponent: LMHtmlUrlDocComponent;

  @Input() public automationId: string;

  // todo change this to be @Input() panel: LMMultiPagePaneSpec; and call
  //  this.setUrl() in ngOnInit.
  //  The panel should be set before ngOnInit is called and should not
  //  change once the component is constructed.
  @Input() set panel(panel: LMMultiPagePaneSpec) {
    this._panel = panel;
    this.setUrl();
    this.isWFM = this.panel?.pane?.paneType === 'WFMPanel';
  }

  get panel(): LMMultiPagePaneSpec {
    return this._panel;
  }

  @Input() set fromDataView(fromDataView: LMDataView) {
    this._fromDataView = fromDataView;
    if (this.htmlDocComponent) {
      this.htmlDocComponent.setDataView(this._fromDataView);
    }
  }

  // ----------------------------------------------------------------------
  // OUTPUTS
  // ----------------------------------------------------------------------
  @Output() landmarkCustomReady = new EventEmitter<any>();
  @Output() panelContentDisplayed = new EventEmitter<LMContentDisplayedEvent>();
  @Output() panelDataUpdated = new EventEmitter<LMPanelTransactionEvent>();

  public url: string = undefined;
  public isWFM = false;
  private _fromDataView: LMDataView = null;
  private _panel: LMMultiPagePaneSpec = null;

  public testVersion1: boolean;

  constructor(
    private lmContextService: LMContextService,
    private lmFormatUtilService: LMFormatUtilService
  ) {}

  ngOnInit() {
    this.testVersion1 = this.lmContextService.testVersion() === AppConstants.TESTVERSION_V1;
  }

  public refresh(request?: LMRefreshRequest): Observable<boolean> {
    if (this.htmlDocComponent) {
      return this.htmlDocComponent.fireLandmarkDataUpdated();
    } else {
      return of (true);
    }
  }

  onLandmarkCustomReady(event: any) {
    if (this.htmlDocComponent) {
      this.htmlDocComponent.setDataView(this._fromDataView);
    }
  }

  onLandmarkApiLoaded(event: any) {
    this.onPanelContentDisplayed({});
  }

  onPanelContentDisplayed(args: any) {
    const event: LMContentDisplayedEvent = { pane: this.panel, args };
    this.panelContentDisplayed.emit(event);
  }

  onNotifyUrlTransactionComplete(event: LMListTransactionEvent) {
    this.panelDataUpdated.emit();
  }

  setUrl() {
    if (this.panel) {
      this.url = this.lmFormatUtilService.formatMessageRule(this.panel.pane.httpUrl, this._fromDataView);
    }
  }

  onHtmlUrlDisplayed(event: any) {
  }
}
